(function(){
  function rewriteSparkLinks(){
    var params = new URLSearchParams(window.location.search);
    params.set('lander', 'spark-ssri-long-form');
    document.querySelectorAll('a[href^="/products/spark"]').forEach(function(link){
      try{
        var url = new URL(link.getAttribute('href'), window.location.origin);
        params.forEach(function(value, key){ if(!url.searchParams.has(key)) url.searchParams.set(key, value); });
        url.searchParams.set('lander', 'spark-ssri-long-form');
        link.setAttribute('href', url.pathname + url.search + url.hash);
      }catch(e){}
    });
  }
  function toggleSticky(){
    var root = document.querySelector('.spark-lf');
    if(!root) return;
    var hero = document.querySelector('[data-section="spark-hero"]');
    var threshold = hero ? Math.max(360, hero.offsetHeight * 0.72) : 520;
    root.classList.toggle('sticky-ready', window.scrollY > threshold);
  }
  rewriteSparkLinks();
  toggleSticky();
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ rewriteSparkLinks(); toggleSticky(); }, {once:true});
  window.addEventListener('load', function(){ rewriteSparkLinks(); toggleSticky(); }, {once:true});
  window.addEventListener('scroll', toggleSticky, {passive:true});
  document.addEventListener('click', function(event){
    var target = event.target && event.target.closest ? event.target.closest('a[href^="/products/spark"]') : null;
    if(target) rewriteSparkLinks();
  }, true);
})();
;(function(){document.documentElement.classList.add('amie-static-rendered');})();
